module.exports = __webpack_public_path__ + "static/flags/BV-436bde95bdca8ca171750bd82c436dcd.gif";